module.exports = {
    base: "/api",
    python: "/pythonapi/api",
    mock: "/mock"
};
